import { HttpClient } from '@angular/common/http';
import { Injectable, EventEmitter, Output } from '@angular/core';
import autobahn from 'autobahn';
import { environment } from '../../environments/environment';

export interface HeartbeatEvent {
  sessionid: string;
  timestamp: number;
}

export interface EIDCardEvent {
  card_number: string;
  date_of_birth: string;
  firstnames: string;
  gender: string;
  issuing_municipality: string;
  location_of_birth: string;
  national_number: string;
  nationality: string;
  nobility: string;
  surname: string;
  validity_begin_date: string;
  validity_end_date: string;
}

@Injectable({
  providedIn: 'root'
})
export class WampService {

  private serviceurl = '';
  private serviceprotocol = 'http';
  private servicehost = '';
  private wsprotocol = 'ws';

  private connection: any = null;
  private wampsession: any = null;
  private remoteip = '';

  // Session
  private phpsessionid = '';
  private userid = -1;

  @Output() connectedEvent = new EventEmitter<boolean>();
  @Output() heartbeatEvent = new EventEmitter<HeartbeatEvent>();
  @Output() eidCardEvent = new EventEmitter<EIDCardEvent>();

  constructor(private http: HttpClient) {
    this._setUrl();
    // if (typeof environment.wsurl === 'undefined') {
    //   // Use browser url
    // } else {
    //   this.servicehost = environment.wsurl;
    // }
    this.openWamp();
  }

  registerSession(sessioninfo)
  {
    console.log('registerSession', sessioninfo);
    this.phpsessionid = sessioninfo.phpsessionid;
    this.userid = sessioninfo.userid;
    this.publish('becare.user.connect', sessioninfo);
    this.register('becare.user.session.' + this.phpsessionid + '.heartbeat', (args => {
//      console.log('Receive heartbeat event',args);
      this.heartbeatEvent.emit({
        sessionid: args[0].sessionid,
        timestamp: args[0].timestamp
      });
      return args[0].sessionid;
    }));
//     this.subscribe('becare.user.session.' + this.phpsessionid + '.update',(args => {
// //      console.log('Receive update event',args);
//       this.updateEvent.emit({
//         sessionid: args[0].sessionid,
//         payload:args[0].payload
//       });
//     }));
    this.subscribe('becare.eid.card.' + this.remoteip, ((args, kwargs, details) => {
      console.log('Receive EID event', args, kwargs, details);
      this.eidCardEvent.emit({
        card_number: kwargs.card.card_number,
        date_of_birth: kwargs.card.date_of_birth,
        firstnames: kwargs.card.firstnames,
        gender: kwargs.card.gender,
        issuing_municipality: kwargs.card.issuing_municipality,
        location_of_birth: kwargs.card.location_of_birth,
        national_number: kwargs.card.national_number,
        nationality: kwargs.card.nationality,
        nobility: kwargs.card.nobility,
        surname: kwargs.card.surname,
        validity_begin_date: kwargs.card.validity_begin_date,
        validity_end_date: kwargs.card.validity_end_date
      });
    }));
  }


  openWamp() {
    const wsurl = this.wsprotocol + '://' + this.servicehost + '/ws/';
    this.connection = new autobahn.Connection({url: wsurl, realm: 'becare'});
    const that = this;
    this.connection.onopen = ((session, details) => {
      that.wampsession = session;
      // Get remote ip
      this.http.get('https://api.ipify.org?format=json').subscribe(results => {
        this.remoteip = (results as any).ip;
        that.connectedEvent.emit(true);
        console.log('Wamp session opened, remote ip : ' + this.remoteip);
      });
    });
    console.log('Connecting to Wamp server ' + wsurl);
    this.connection.open();
  }

  publish(path, payload) {
    if (this.wampsession != null) {
      this.wampsession.publish(path, [payload]);
    }
  }

  subscribe(path, callback) {
    if (this.wampsession != null) {
      this.wampsession.subscribe(path, callback);
    }
  }

  register(path, callback) {
    if (this.wampsession != null) {
      this.wampsession.register(path, callback);
    }
  }

  // Helpers
  _setUrl() {
    const parser = document.createElement('a');
    parser.href = window.location.href;
    this.serviceurl = window.location.href;
    this.servicehost = parser.host;
    this.serviceprotocol = parser.protocol;
//    console.log('url ' + this.serviceurl + ' host ' + this.servicehost + ' protocol ' + this.serviceprotocol);
    if (this.serviceprotocol === 'https:') {
        // set WebSocket Secured
        this.wsprotocol = 'wss';
    }
  }
}
